const baseButtonStyle = {
  maxWidth: "6rem",
  minWidth: "6rem",
  color: "white",
};

const normal = {
  displayText: "Normal",
  value: "normal",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#A8A878",
  },
};

const fire = {
  displayText: "Fire",
  value: "fire",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#F08030",
  },
};

const fighting = {
  displayText: "Fighting",
  value: "fighting",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#C03028",
  },
};

const water = {
  displayText: "Water",
  value: "water",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#6890F0",
  },
};

const flying = {
  displayText: "Flying",
  value: "flying",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#A890F0",
  },
};

const grass = {
  displayText: "Grass",
  value: "grass",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#78C850",
  },
};

const poison = {
  displayText: "Poison",
  value: "poison",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#A040A0",
  },
};

const electric = {
  displayText: "Electric",
  value: "electric",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#F8D030",
  },
};

const ground = {
  displayText: "Ground",
  value: "ground",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#E0C068",
  },
};

const psychic = {
  displayText: "Psychic",
  value: "psychic",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#F85888",
  },
};

const rock = {
  displayText: "Rock",
  value: "rock",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#B8A038",
  },
};

const ice = {
  displayText: "Ice",
  value: "ice",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#98D8D8",
  },
};

const bug = {
  displayText: "Bug",
  value: "bug",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#A8B820",
  },
};

const dragon = {
  displayText: "Dragon",
  value: "dragon",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#7038F8",
  },
};

const ghost = {
  displayText: "Ghost",
  value: "ghost",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#705898",
  },
};

const dark = {
  displayText: "Dark",
  value: "dark",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#705848",
  },
};

const steel = {
  displayText: "Steel",
  value: "steel",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#B8B8D0",
  },
};

const fairy = {
  displayText: "Fairy",
  value: "fairy",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#EE99AC",
  },
};

const typeButtonData = [
  normal,
  fire,
  fighting,
  water,
  flying,
  grass,
  poison,
  electric,
  ground,
  psychic,
  rock,
  ice,
  bug,
  dragon,
  ghost,
  dark,
  steel,
  fairy,
];

export default typeButtonData;
